import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AdminLoginComponent } from './components/admin-login/admin-login.component';
import { UserSurveyComponent } from './components/user-survey/user-survey.component';
import { AdminComponent } from './components/admin/admin.component';
import { AdminsComponent } from './components/admins/admins.component';
import { ListAdminsComponent } from './components/list-admins/list-admins.component';
import { ListSurveysComponent } from './components/list-surveys/list-surveys.component';
import { TakeSurveyComponent } from './components/take-survey/take-survey.component';
import { TakeSurveyQuestionsComponent } from './components/take-survey-questions/take-survey-questions.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { QuestionComponent } from './components/question/question.component';
import { CreateSurveyComponent } from './components/create-survey/create-survey.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AddQuestionComponent } from './components/add-question/add-question.component';
import { AddOptionsComponent } from './components/add-options/add-options.component';
import { AddAdminComponent } from './components/add-admin/add-admin.component';
import { SurveyDetailsComponent } from './components/survey-details/survey-details.component';
import { SiteHeaderComponent } from './components/site-header/site-header.component';
import { SiteFooterComponent } from './components/site-footer/site-footer.component';
import { ResultsComponent } from './components/results/results.component';
import { ConclusionComponent } from './components/conclusion/conclusion.component';
import { NgbAccordionModule } from '@ng-bootstrap/ng-bootstrap';
import { MatTabsModule } from '@angular/material/tabs';
import { MatSelectModule } from '@angular/material/select';


@NgModule({ declarations: [
        AppComponent,
        AdminLoginComponent,
        UserSurveyComponent,
        AdminComponent,
        ListSurveysComponent,
        TakeSurveyComponent,
        TakeSurveyQuestionsComponent,
        QuestionComponent,
        CreateSurveyComponent,
        AddQuestionComponent,
        AddOptionsComponent,
        AddAdminComponent,
        SurveyDetailsComponent,
        SiteHeaderComponent,
        SiteFooterComponent,
        ResultsComponent,
        ConclusionComponent,
        AdminsComponent,
        ListAdminsComponent
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        FormsModule,
        ReactiveFormsModule,
        BrowserAnimationsModule,        
        NgbAccordionModule,       
        MatTabsModule,     
        MatSelectModule], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class AppModule { }
